import { render, staticRenderFns } from "./BaseHeader.vue?vue&type=template&id=efe9fe06&scoped=true&"
import script from "./BaseHeader.vue?vue&type=script&lang=js&"
export * from "./BaseHeader.vue?vue&type=script&lang=js&"
import style0 from "./BaseHeader.vue?vue&type=style&index=0&id=efe9fe06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efe9fe06",
  null
  
)

export default component.exports